export default __webpack_public_path__ + "static/media/logo-text-only.e774d501.svg";